import { Field, InputType } from 'type-graphql'

@InputType()
export class BasicAuthRegisterArgs {
  @Field(() => String)
  recaptchaToken: string

  @Field(() => String)
  username: string

  @Field(() => String)
  password: string

  @Field(() => String)
  name: string

  @Field(() => String)
  phone: string
}
